<div class="facturacion-container">
  <h1 class="facturacion-titulo">Facturación por cliente</h1>

  <mat-tab-group>
    <!-- ════════════════ FACTURACIÓN ════════════════ -->
    <mat-tab label="Facturación">
      <div class="facturacion-tab">
        <div class="facturacion-mes-controls">
          <span class="facturacion-hint">Período del resumen:</span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Mes</mat-label>
            <mat-select [(ngModel)]="mesSel" (selectionChange)="onMesChange()">
              @for (m of mesesOpciones; track m.valor) {
                <mat-option [value]="m.valor">{{ m.nombre }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Año</mat-label>
            <mat-select [(ngModel)]="anioSel" (selectionChange)="onMesChange()">
              @for (a of aniosOpciones; track a) {
                <mat-option [value]="a">{{ a }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        @if (loading || loadingResumenes) {
          <div class="facturacion-loading">
            <mat-spinner diameter="50"></mat-spinner>
          </div>
        } @else if (clientes.length) {
          <div class="facturacion-grid">
            @for (cliente of clientes; track cliente._id) {
              <mat-card class="facturacion-card">
                <div class="facturacion-card-top">
                  <span class="facturacion-card-nombre">
                    {{ cliente.nombre }}
                  </span>
                </div>
                <mat-divider></mat-divider>

                <mat-card-content class="facturacion-card-body">
                  @if (esBonificado(cliente)) {
                    <p class="facturacion-sin">Bonificado — no se cobra.</p>
                  } @else if (resumenDe(cliente); as r) {
                    @for (cat of categorias; track cat.key) {
                      <div class="facturacion-linea">
                        <span>{{ cat.label }}</span>
                        <span class="facturacion-cant">
                          {{ r.resumen?.[cat.key]?.cantidadFacturada || 0 }} /
                          {{ r.resumen?.[cat.key]?.cantidadTotal || 0 }}
                        </span>
                      </div>
                    }
                    <mat-divider></mat-divider>
                    <div class="facturacion-pago">
                      <span>Total dispositivos</span>
                      <strong>{{ r.resumen?.total || 0 }}</strong>
                    </div>
                  } @else {
                    <p class="facturacion-sin">Sin resumen del mes.</p>
                  }
                </mat-card-content>
              </mat-card>
            }
          </div>
        } @else {
          <p class="facturacion-vacio">No hay clientes de nivel 1.</p>
        }
      </div>
    </mat-tab>

    <!-- ════════════════ CONFIGURACIÓN ════════════════ -->
    <mat-tab label="Configuración">
      <div class="facturacion-tab">
        <div class="facturacion-header">
          <span class="facturacion-header-spacer"></span>
          @if (!loading) {
            <span class="facturacion-contador">
              {{ conFacturacion }} / {{ clientes.length }} con facturación
            </span>
          }
          <button irxBoton="secundario" (click)="crearResumen()">
            <mat-icon>event_note</mat-icon>
            Crear resumen
          </button>
          <button
            irxBoton="principal"
            (click)="agregarExcepcion()"
          >
            <mat-icon>add</mat-icon>
            Agregar excepción
          </button>
        </div>

        @if (loading) {
          <div class="facturacion-loading">
            <mat-spinner diameter="50"></mat-spinner>
          </div>
        } @else if (clientes.length) {
          <div class="facturacion-grid">
            @for (cliente of clientes; track cliente._id) {
              <mat-card
                class="facturacion-card"
                [class.facturacion-card--ok]="tieneFacturacion(cliente)"
                [class.facturacion-card--falta]="!tieneFacturacion(cliente)"
              >
                <div class="facturacion-card-top">
                  <span class="facturacion-card-nombre">
                    {{ cliente.nombre }}
                  </span>
                  @if (tieneFacturacion(cliente)) {
                    <mat-icon
                      class="icono-ok"
                      matTooltip="Facturación configurada"
                    >
                      check_circle
                    </mat-icon>
                  } @else {
                    <mat-icon class="icono-falta" matTooltip="Sin facturación">
                      error_outline
                    </mat-icon>
                  }
                </div>

                @if (esBonificado(cliente) || esIndependiente(cliente)) {
                  <div class="facturacion-badges">
                    @if (esIndependiente(cliente)) {
                      <span class="facturacion-badge facturacion-badge--indep">
                        Independiente
                      </span>
                    }
                    @if (esBonificado(cliente)) {
                      <span class="facturacion-badge facturacion-badge--bonif">
                        Bonificado
                      </span>
                    }
                  </div>
                }

                <mat-divider></mat-divider>

                <mat-card-content class="facturacion-card-body">
                  @if (tieneFacturacion(cliente)) {
                    <div class="facturacion-linea">
                      <mat-icon>
                        {{
                          facturacionDe(cliente)?.activa
                            ? 'check_circle'
                            : 'cancel'
                        }}
                      </mat-icon>
                      <span>Facturación</span>
                      <strong>
                        {{
                          facturacionDe(cliente)?.activa ? 'Activa' : 'Inactiva'
                        }}
                      </strong>
                    </div>
                  } @else {
                    <p class="facturacion-sin">Sin facturación configurada</p>
                  }
                </mat-card-content>

                <mat-card-actions align="end">
                  @if (tieneFacturacion(cliente)) {
                    <button
                      irxBoton="peligro-texto"
                      (click)="eliminarFacturacion(cliente)"
                    >
                      Eliminar
                    </button>
                  }
                  <button
                    irxBoton="tonal"
                    (click)="crearOEditar(cliente)"
                  >
                    {{ tieneFacturacion(cliente) ? 'Editar' : 'Crear' }}
                  </button>
                </mat-card-actions>
              </mat-card>
            }
          </div>
        } @else {
          <p class="facturacion-vacio">No hay clientes de nivel 1.</p>
        }
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
